'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002440 from "./presto.-Two-Factor-Auth-View$$anon$40.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002442 from "./presto.-Two-Factor-Auth-View$$anon$42.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002444 from "./presto.-Two-Factor-Auth-View$$anon$44.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002446 from "./presto.-Two-Factor-Auth-View$$anon$46.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$39() {
  this.bCU = null;
  this.bCM = null;
  this.bCN = false;
  this.bCV = null;
  this.bCW = false;
  this.bCZ = null;
  this.bCS = null;
  this.bCT = false;
  this.bCO = null;
  this.bCP = false;
  this.bCQ = null;
  this.bCR = false;
  this.bCX = false;
  this.bCY = false;
  this.bCU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bCZ = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$39 as $c_Lpresto_TwoFactorAuthView$$anon$39 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$39.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$39;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$39() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$39 as $h_Lpresto_TwoFactorAuthView$$anon$39 };
$h_Lpresto_TwoFactorAuthView$$anon$39.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bCU;
});
$p.L = (function() {
  if ((!this.bCN)) {
    this.bCM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bCN = true;
  }
  return this.bCM;
});
$p.O = (function() {
  if ((!this.bCW)) {
    this.bCV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bCW = true;
  }
  return this.bCV;
});
$p.E = (function() {
  return this.bCZ;
});
$p.t = (function() {
  if ((!this.bCT)) {
    this.bCS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bCT = true;
  }
  return this.bCS;
});
$p.M = (function() {
  if ((!this.bCP)) {
    this.bCO = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002440.$c_Lpresto_TwoFactorAuthView$$anon$40(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002442.$c_Lpresto_TwoFactorAuthView$$anon$42())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002444.$c_Lpresto_TwoFactorAuthView$$anon$44())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bCP = true;
  }
  return this.bCO;
});
$p.Q = (function() {
  if ((!this.bCR)) {
    this.bCQ = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002446.$c_Lpresto_TwoFactorAuthView$$anon$46();
    this.bCR = true;
  }
  return this.bCQ;
});
$p.w = (function() {
  if ((!this.bCY)) {
    this.bCX = false;
    this.bCY = true;
  }
  return this.bCX;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee443) => ((p) => \u03b4scrutinee443.z5(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$39 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$39, "presto.TwoFactorAuthView$$anon$39", ({
  SB: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$39 as $d_Lpresto_TwoFactorAuthView$$anon$39 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$39.js.map
